module.exports = __webpack_public_path__ + "assets/img/1721589512664_.pic_hd.81c2bed9.jpg";